/* @flow */
import File from 'entities/File';
import { getGlyphName } from 'lib/FileTypes';
import Glyph from 'components/Glyph.jsx';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import MessageItemImageAttachment from './MessageItemImageAttachment.jsx';
import React from 'react';
import Video from 'components/Video.jsx';
import Audio from 'components/Audio.jsx';
import filesize from 'filesize';
import cx from 'classnames';
import './styles/MessageItemAttachment.scss';

class MessageItemAttachment extends React.Component {
  static propTypes = {
    file: React.PropTypes.instanceOf(File).isRequired,
  };

  state = {
    hover: false,
  };

  hoverOn = () => this.setState({ hover: true });

  hoverOff = () => this.setState({ hover: false });

  renderAudioPreview(file: File) {
    return (
      <div className="MessageItemAttachment-multimedia">
        <Audio
          src={file.getUrls().cdn}
          key={file.id}
        />
      </div>
    );
  }

  renderImagePreview(file: File) {
    return (
      <div className="MessageItemAttachment-multimedia">
        <MessageItemImageAttachment file={file} />
      </div>
    );
  }

  renderVideoPreview(file: File) {
    return (
      <div className="MessageItemAttachment-multimedia MessageItemAttachment-video">
        <Video
          src={file.getUrls().cdn}
          key={file.id}
        />
      </div>
    );
  }

  render() {
    const { file } = this.props;
    const type = file.getContentType();

    if (Image.isSupportedType(type)) {
      return this.renderImagePreview(file);
    } else if (Audio.isSupportedType(type)) {
      return this.renderAudioPreview(file);
    } else if (Video.isSupportedType(type)) {
      return this.renderVideoPreview(file);
    }

    let size = file.getSize();
    if (size) {
      size = filesize(size, { round: 0 }).toUpperCase();
    }

    const urls = file.getUrls();
    const glyphName = this.state.hover ? 'download' : getGlyphName(type);

    return (
      <div className="MessageItemAttachment">
        <Link
          className="MessageItemAttachment-icon"
          onMouseLeave={this.hoverOff}
          onMouseEnter={this.hoverOn}
          href={urls.cdn}
          target="_blank"
          eventElementName="MessageItemAttachment-icon">
          <Glyph name={glyphName} size="xlarge" solo />
        </Link>
        <div
          className={cx({
            'MessageItemAttachment-info': true,
            hovered: this.state.hover }
          )}>
          <Link
            className="MessageItemAttachment-name"
            href={urls.cdn}
            target="_blank"
            eventElementName="MessageItemAttachment-name">
            {file.getName()}
          </Link>
          <div className="MessageItemAttachment-metadata">
            <em>{size}</em>
          </div>
        </div>
      </div>
    );
  }
}

export default MessageItemAttachment;



// WEBPACK FOOTER //
// ./src/chat/components/MessageItemAttachment.jsx